module.exports = __webpack_public_path__ + "img/samara.14ddfce9.png";